import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import Hero from "../../../components/ui/Hero";

export default function CarrusellPostulate() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        pt: { xs: 10, lg: 15 },
        pb: { xs: 8, lg: 12 },
        bgcolor: "#f8fafc",
        overflow: "hidden",
      }}
    >
      {/* Círculos decorativos */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          right: "-10%",
          width: 800,
          height: 800,
          borderRadius: "50%",
          bgcolor: "rgba(0, 86, 179, 0.05)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Hero t={t} prefix={"postulate"} />

      </Container>
    </Box>
  );
}

